import { FC, ChangeEvent, FocusEvent } from 'react';
import classnames from 'classnames';

export interface IHeaderRangeCalculatorProps {
  label?: string;
  inputValue: string;
  maxLength: number;
  onChangeInputHandler: (e: ChangeEvent<HTMLInputElement>) => void;
  onBlurInputHandler: (e: FocusEvent<HTMLInputElement>) => void;
  prefix?: string;
  prefixPosition?: 'first' | 'last';
  classHeaderTitle?: string;
  classHeaderInputBlock?: string;
  classHeaderInput?: string;
  classHeaderPrefix?: string;
}

const HeaderRangeCalculator: FC<IHeaderRangeCalculatorProps> = ({
  label,
  inputValue,
  maxLength,
  onChangeInputHandler,
  onBlurInputHandler,
  prefix,
  prefixPosition,
  classHeaderTitle,
  classHeaderInputBlock,
  classHeaderInput,
  classHeaderPrefix,
}) => {
  return (
    <>
      <span className={classnames('range__header-title', classHeaderTitle)}>{label}</span>
      <div className={classnames('range__header-input-block', classHeaderInputBlock)}>
        {prefixPosition === 'first' && (
          <span className={classnames('range__header-prefix', classHeaderPrefix)}>{prefix}</span>
        )}
        <input
          type="text"
          maxLength={maxLength}
          className={classnames('range__header-input', classHeaderInput)}
          value={inputValue}
          onChange={onChangeInputHandler}
          onBlur={onBlurInputHandler}
          inputMode="numeric"
        />
        {prefixPosition !== 'first' && (
          <span className={classnames('range__header-prefix', classHeaderPrefix)}>{prefix}</span>
        )}
      </div>
    </>
  );
};

export default HeaderRangeCalculator;
